import { useLayoutEffect } from "react";

export function useScrollReveal(): void {
  useLayoutEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const els = document.querySelectorAll<HTMLElement>("[data-reveal]:not(.is-revealed)");

    if (reduced || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-revealed"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.18 }
    );

    // Reveal anything already in the viewport immediately (above-the-fold content
    // shouldn't fade in on first paint), then observe the rest.
    const viewportH = window.innerHeight;
    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < viewportH && rect.bottom > 0) {
        el.classList.add("is-revealed");
      } else {
        io.observe(el);
      }
    });

    return () => io.disconnect();
  }, []);
}
